import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.2);
  display: ${(props) => (props.loading === 'true' ? 'flex' : 'none')};
  align-items: center;
  justify-content: center;
`;
